export type NestedDirtyFields<T> = {
  [K in keyof T]?: T[K] extends object ? NestedDirtyFields<T[K]> : boolean;
};

type FlatDirtyFields = Record<string, boolean>;

export default function flattenDirtyFields<T>(fields: NestedDirtyFields<T>, prefix = ""): FlatDirtyFields {
  return Object.entries(fields).reduce((acc, [key, value]) => {
    const newKey = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === "object" && !Array.isArray(value)) {
      Object.assign(acc, flattenDirtyFields(value as NestedDirtyFields<T[keyof T]>, newKey));
    } else {
      acc[newKey] = !!value;
    }
    return acc;
  }, {} as FlatDirtyFields);
}
